import $ from 'jquery';
import 'slick-carousel';
import bindEvent from '../../scripts/util/bindEvent';
import isViewport from '../../scripts/util/window/isViewport';
import {desktop} from '../../scripts/util/window/isViewport';

const selectors = {
	categoryList: '.js-category-list',
	category: '.js-category',
	previewList: '.js-preview-list',
	preview: '.js-preview',
	previewActive: '.preview-list__item_state_active',
	previewSliderDot: '.js-preview-dots .slick-dots li',
	active: {
		category: '.category-list__item_state_active'
	},
	stylishDesign: '.main__stylish-design'
};

const classes = {
	slick: 'slick-slider',
	active: {
		category: 'category-list__item_state_active',
		preview: 'preview-list__item_state_active'
	}
};

const slickSettings = {
	slidesToShow: 3,
	slidesToScroll: 1,
	arrows: false,
	dots: false,
	infinite: true,
	centerMode: true,
	focusOnSelect: true,
	variableWidth: true,
	mobileFirst: true,
	responsive: [
		{
			breakpoint: 1200,
			settings: 'unslick'
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 5
			}
		}
	]
};

const previewSliderSettings = {
	arrows: false,
	infinite: false,
	dots: true,
	autoplay: true,
	autoplaySpeed: 3000,
	appendDots: '.js-preview-dots',
	slidesToShow: 1,
	slidesToScroll: 3,
	centerMode: true,
	variableWidth: true,
	focusOnSelect: true,
	responsive: [
		{
			breakpoint: 325,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				centerMode: false,
				focusOnSelect: false
			}
		}
	]
};

const $slider = $(selectors.categoryList);
const previewList = document.querySelector(selectors.previewList);
const categoryList = document.querySelector(selectors.categoryList);

const setActiveEl = (activeEl, el, activeClass) => {
	if (activeEl && el) {
		activeEl.classList.remove(activeClass);
		el.classList.add(activeClass);
	}
};

const searchTargetEl = (parent, id) => parent.querySelector(`[data-id='${id}']`);
const searchActiveEl = (parent, activeClass) => parent.querySelector(`.${activeClass}`);

const changePreview = id => {
	const previewTarget = searchTargetEl(previewList, id);
	const previewActive = searchActiveEl(previewList, classes.active.preview);
	const categoryTarget = searchTargetEl(categoryList, id);
	const categoryActive = searchActiveEl(categoryList, classes.active.category);

	$(selectors.previewActive).slick('unslick');
	setActiveEl(previewActive, previewTarget, classes.active.preview);
	$(selectors.previewActive).slick(previewSliderSettings);
	setActiveEl(categoryActive, categoryTarget, classes.active.category);
};

const onClick = e => {
	const target = e.currentTarget;
	const id = target.dataset.id;
	changePreview(id);
};

const onSlideChange = (e, slick, currentSlide, nextSlide) => {
	changePreview(nextSlide);
};

const onSlideChangeAfter = (e, slick, currentSlide) => {
	const countPreviews = $(e.target).find('.preview').length;
	const currentCategory = $(selectors.active.category);
	const currentCategoryId = currentCategory.data('id');
	const nextCategoryId = currentCategory.data('id') + 1;
	const countCategories = $(selectors.category).length;
	let nextCategory = $(selectors.categoryList).find('li[data-id=' + nextCategoryId + ']');

	if (currentSlide === countPreviews - 1) {
		if (currentCategoryId === countCategories - 1) {
			nextCategory = $(selectors.categoryList).find('li[data-id=0]');
		}
		setTimeout(function () {
			nextCategory.trigger('click');
		}, 3000);
	}
};

const initSlider = () => {
	const isInit = categoryList.classList.contains(classes.slick);
	if (!isInit && isViewport(desktop)) {
		$slider.slick(slickSettings);
	}
};

const $sliderPreviews = $(selectors.previewList);

const setHandlers = () => {
	bindEvent(selectors.category, 'click', onClick);
	window.addEventListener('resize', initSlider);

	$slider.on('beforeChange', (e, slick, currentSlide, nextSlide) => onSlideChange(e, slick, currentSlide, nextSlide));
	$sliderPreviews.on('afterChange', (e, slick, currentSlide) => onSlideChangeAfter(e, slick, currentSlide));
	$(selectors.previewSliderDot).on('click', function () {
		$(selectors.previewActive).slick('slickPause');
	});

	let slideShowStarted = false;
	$(window).scroll(function () {
		if ($(window).scrollTop() > $(selectors.stylishDesign).offset().top + 200 && slideShowStarted === false) {
			$(selectors.previewActive).slick(previewSliderSettings);
			slideShowStarted = true;
		}
	});
};

const render = () => {
	if (categoryList) {
		setHandlers();
		initSlider();
	}
};

export default render;
